/**
 * Branding visual del tenant para share (OG) y PWA (URLs / resolución).
 * Sin `sharp`: este módulo entra al bundle del browser (market loaders).
 * PNG con iniciales vive en `tenant-brand-image.server.ts` (solo API routes).
 */
export function safeHexColor(c: string | null | undefined, fallback: string): string {
  if (!c) return fallback;
  const t = c.trim();
  return /^#([0-9a-fA-F]{3}|[0-9a-fA-F]{6})$/.test(t) ? t : fallback;
}

/** Iniciales legibles: "Tienda de Bebidas" → "TB", "SHP" → "SH". */
export function tenantInitials(name: string): string {
  const clean = (name || "").trim().replace(/\s+/g, " ");
  if (!clean) return "?";
  const parts = clean.split(" ").filter(Boolean);
  if (parts.length >= 2) {
    return (parts[0]![0]! + parts[1]![0]!).toUpperCase();
  }
  const word = parts[0]!;
  return word.slice(0, 2).toUpperCase();
}

function absUrl(url: string, origin?: string): string {
  const u = url.trim();
  if (!u) return u;
  if (/^https?:\/\//i.test(u)) return u;
  if (u.startsWith("//")) return `https:${u}`;
  const base = (origin || "").replace(/\/$/, "");
  if (!base) return u;
  return u.startsWith("/") ? `${base}${u}` : `${base}/${u}`;
}

export function tenantBrandIconUrl(slug: string, origin?: string): string {
  return absUrl(`/api/tenant-branding/${encodeURIComponent(slug)}/icon`, origin);
}

export function tenantBrandOgUrl(slug: string, origin?: string): string {
  return absUrl(`/api/tenant-branding/${encodeURIComponent(slug)}/og`, origin);
}

/**
 * Prioridad share/OG: SEO og → logo → hero → primera imagen de producto → PNG iniciales.
 */
export function resolveTenantShareImage(input: {
  seoOgImageUrl?: string | null;
  logoUrl?: string | null;
  heroImageUrl?: string | null;
  productImageUrls?: Array<string | null | undefined>;
  slug: string;
  origin?: string;
}): string {
  const candidates = [
    input.seoOgImageUrl,
    input.logoUrl,
    input.heroImageUrl,
    ...(input.productImageUrls ?? []),
  ];
  for (const c of candidates) {
    const t = (c ?? "").trim();
    if (!t) continue;
    // Evitar assets genéricos de la plataforma si alguien los pegó por error.
    if (/\/og-cover|structura-market|\/icon-192\.png|\/icon-512\.png/i.test(t)) continue;
    return absUrl(t, input.origin);
  }
  return tenantBrandOgUrl(input.slug, input.origin);
}
